import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=bd1bf6fc&scoped=true&"
import script from "./LoginAs.vue?vue&type=script&lang=js&"
export * from "./LoginAs.vue?vue&type=script&lang=js&"
import style0 from "./LoginAs.vue?vue&type=style&index=0&id=bd1bf6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1bf6fc",
  null
  
)

export default component.exports